import { gql } from "@apollo/client";

// Réutilisation de la query existante plutôt que de la dupliquer.
export { QR_LIST_CONVERSATION } from "../../../../app/components/event/messenger/graphQl/MessengerAPI";

export const MT_ASSIGN_CONVERSATION = gql`
  mutation assignConversation($conversationId: String!) {
    MT_ASSIGN_CONVERSATION(conversationId: $conversationId) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        assignedAgentId
        status
      }
    }
  }
`;

// Mutation unique pour tout changement de statut (archiver, clôturer...) : l'API attend
// toujours un PUT avec l'objet conversation complet, géré côté zorni-controller.
export const MT_PATCH_CONVERSATION_STATUS = gql`
  mutation patchStatus($conversationId: String!, $status: ConversationStatusEnum!) {
    MT_PATCH_CONVERSATION_STATUS(conversationId: $conversationId, status: $status) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        id
        status
      }
    }
  }
`;
